"use client"

import { ShoppingBag } from "lucide-react"

import { BAR_BUTTON, BuyBar } from "@/components/layout/sticky-buy-bar"
import { Button } from "@/components/ui/button"
import { comboShortfall, startingColours, type StorefrontCombo } from "@/features/combos/combo"
import { useAddCombo, useComboPicks } from "@/features/combos/hooks/use-combo-picks"

/** The combo page's bar: the pack's price, and Add to cart for the colours picked above. */
export function ComboBuyBar({
  combo,
  freeShipping,
}: {
  combo: StorefrontCombo
  freeShipping: boolean
}) {
  const picks = useComboPicks()
  const colours =
    picks.slug === combo.slug
      ? picks.colours
      : startingColours(combo.product.colourways, combo.quantity)
  const addToCart = useAddCombo(combo)
  const short = comboShortfall(combo.product.colourways, colours).length > 0

  return (
    <BuyBar price={combo.price} freeShipping={freeShipping}>
      <Button
        type="button"
        variant="primary"
        size="md"
        full
        disabled={short}
        onClick={(e) => addToCart(colours, e.currentTarget)}
        className={BAR_BUTTON}
      >
        <ShoppingBag className="size-4" strokeWidth={1.9} />
        {short ? "Pick another colour" : "Add to cart"}
      </Button>
    </BuyBar>
  )
}
